import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { environment } from 'src/environments/environment';
import { DialogService } from '../dialogService/dialog-service';
import { RequestService } from '../requestService/request.service';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {
  env = environment;
  constructor(private requestService: RequestService, private dialogService: DialogService, private dialog: MatDialog) { }

  // Get all the available products for an asset
  getProductsAsset(id) {
    let self = this;
    let req = {
      url: "/api/products/getAssetProducts",
      req: {
        assetId: id,
      }
    };

    return new Promise(resolve => {
      this.requestService.mainPostRequest(req).then((resp: any) => {
        // It has products
        if (resp.data && resp.data.products && resp.data.products.length) {
          // Select Product
          this.dialogService.openPaymentDialog({
            products: resp.data.products,
            assetId: id,
            productsService: this
          }).subscribe(paymentStatus => {
            resolve(paymentStatus);
          });
        } else {
          this.dialogService.openConfirmDialog({
            title: "gen_subscribe",
            message: "subscribe_asset_no_products_msg",
            confirm: "gen_ok"
          }).subscribe(result => {
            resolve(false);
          });
        }
      });
    });
  }

  // Get all the available products for an asset
  getProducts() {
    let req = {
      url: "/api/products/getProducts",
      req: {
        type: 0,
      }
    };

    return this.requestService.mainPostRequest(req);
  }

  // Purchase a product
  purchaseProduct(params) {
    let req = {
      url: "/api/products/purchaseProduct",
      req: {
        productId: params.productId,
        paymentMethod: params.paymentMethod
      }
    };

    if (params && params.assetId) {
      req.req["assetId"] = params.assetId
    }

    return new Promise(resolve => {
      let win = window.open("about:blank", "_blank", "width=500,height=500");
      this.requestService.mainPostRequest(req).then((resp: any) => {
        win.location.href = resp.data.paymentUrl;
        resolve(resp.data);
      });
    });
  }

  // Purchase a product
  cancelProduct(params) {
    let req = {
      url: "/api/Products/cancelSubscription",
      req: {
        subscriptionId: params.productId
      }
    }
    return this.requestService.mainPostRequest(req);
  }

  checkOutToken(token) {
    let req = {
      url: "/api/products/checkout?jwt=" + token
    };

    return this.requestService.mainGetRequest(req);
  }

  // Return the available parental ratings
  getDefinitions(selection) {
    const definitions = [{
      id: 0,
      title: "VLD",
      checked: true
    }, {
      id: 1,
      title: "LD",
      checked: false
    }, {
      id: 2,
      title: "SD",
      checked: false
    }, {
      id: 3,
      title: "HD",
      checked: false
    }, {
      id: 4,
      title: "FHD",
      checked: false
    }];

    return definitions.find(obj => {
      return obj.id == selection;
    });
  }

  // Return Dialog Params and Payment Methods
  getPaymentMethods() {
    let paymentOptions = new Array();
    this.env.features.paymentMethods.forEach(obj => {
      switch (obj) {
        case 1:
          paymentOptions.push({
            id: 1,
            title: "payment_paypal",
            icon: "fab fa-cc-paypal"
          });
          break;
        case 2:
          paymentOptions.push({
            id: 2,
            title: "payment_credit_card",
            icon: "far fa-credit-card"
          });
          break;
      }
    })
    return paymentOptions;
  }

  // Get the rentals history for the user
  getRentals(params) {
    let req = {
      url: "/api/products/getRentalPayments",
      req: {
        count: params.count ? params.count : 20,
        offset: params.offset ? params.offset : 0,
        statuses: [1]
      }
    };

    return this.requestService.mainPostRequest(req);
  }

  // Polling API which is checking the status of the order code
  checkPayment(params) {
    let req = {
      url: "/api/Products/checkPayment",
      req: {
        orderCode: params.orderCode
      }
    }

    return this.requestService.mainPostRequest(req);
  }

  // Subscribe into a product
  subscribeSingleProduct(product) {
    return new Promise(resolve => {
      this.dialogService.openPaymentDialog({
        products: [product],
        productsService: this
      }).subscribe(paymentStatus => {
        resolve(paymentStatus);
      });
    });
  }
}